import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import faqAtom from '../faq.atom'
import eventBus from '../../../../services/eventBus'
import arrayUtils from '../../../../utils/array.utils'

const useFaqEventsSubscriptions = () => {
  const setFaqState = useSetRecoilState(faqAtom)

  useEffect(() => {
    const createGroupSub = eventBus.sub('faq.groups.created', (item) => {
      setFaqState((prev) => ({ ...prev, categories: [item, ...prev.categories] }))
    })

    const createArticleSub = eventBus.sub('faq.articles.created', (item) => {
      setFaqState((prev) => ({ ...prev, articles: [item, ...prev.articles] }))
    })

    const updateGroupSub = eventBus.sub('faq.groups.updated', ({ id, updates }) => {
      setFaqState((prev) => ({
        ...prev,
        categories: arrayUtils.updateItem({ items: prev.categories }, { ...updates, id }).items,
      }))
    })

    const updateArticleSub = eventBus.sub('faq.articles.updated', ({ id, updates }) => {
      setFaqState((prev) => ({
        ...prev,
        articles: arrayUtils.updateItem({ items: prev.articles }, { ...updates, id }).items,
      }))
    })

    const groupRemoveSub = eventBus.sub('faq.groups.deleted', (id) => {
      setFaqState((prev) => ({
        ...prev,
        categories: arrayUtils.removeItem({ items: prev.categories }, id).items,
      }))
    })

    const articleRemoveSub = eventBus.sub('faq.articles.deleted', (id) => {
      setFaqState((prev) => ({
        ...prev,
        articles: arrayUtils.removeItem({ items: prev.articles }, id).items,
      }))
    })

    return () => {
      createGroupSub()
      createArticleSub()
      updateGroupSub()
      updateArticleSub()
      groupRemoveSub()
      articleRemoveSub()
    }
  }, [])
}

export default useFaqEventsSubscriptions
